module.exports = __webpack_public_path__ + "img/sp.4189671b.png";